import type { AgreementsPayload, TaskPaneReportFilter } from '../models/agreements.model';
import { statusNameToCode } from '../agreements.constants';
import { resolveReportRecordCount } from '../report-record-count.constants';
import { parseCsvValues } from '../../shared/dom.util';

/**
 * Parses comma-separated status names or numeric codes from a text field (legacy / tests).
 */
export function parseStatuses(rawValue: string): number[] {
    if (!rawValue) {
        return [];
    }

    const values = parseCsvValues(rawValue);
    const parsed = values
        .map((value) => {
            if (/^\d+$/.test(value)) {
                return Number(value);
            }

            return statusNameToCode[value.toLowerCase()];
        })
        .filter((value): value is number => Number.isInteger(value));

    return Array.from(new Set(parsed));
}

function agreementsDomainFieldsExcludingPagination(
    filter: TaskPaneReportFilter
): Omit<TaskPaneReportFilter, 'recordCount' | 'startIndex'> {
    const { recordCount, startIndex, ...rest } = filter;
    void recordCount;
    void startIndex;
    return rest;
}

/** Builds the Activity Handler envelope from a filter object (pure — no DOM). */
export function buildAgreementsPayloadFromFilter(filter: TaskPaneReportFilter): AgreementsPayload {
    const recordCount = resolveReportRecordCount(filter.recordCount);
    const domainOnly = agreementsDomainFieldsExcludingPagination(filter);

    const agreementsFilter = {
        startIndex: 0,
        recordCount,
        ...domainOnly,
    };

    return {
        activity: 'Get-Agreements',
        isAsync: false,
        data: { filter: agreementsFilter },
    };
}
